import { useContext } from 'react'

import Grid from '@mui/material/Grid'

import { FormContext } from 'layouts/organisation-member/constants'

import Analytics from '../Analytics'
import Contact from '../Contact'
import Details from '../Details'
import FeedbackTable from '../FeedbackTable'
import Notes from '../Notes'

function MainForm() {
	const formContext = useContext(FormContext)
	const { isNew } = formContext

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<Details />
			</Grid>
			<Grid item xs={12}>
				<Contact />
			</Grid>
			<Grid item xs={12}>
				<Notes />
			</Grid>
			{!isNew && (
				<>
					<Grid item xs={12}>
						<Analytics />
					</Grid>
					<Grid item xs={12}>
						<FeedbackTable />
					</Grid>
				</>
			)}
		</Grid>
	)
}

export default MainForm
